<!-- <keep-alive> -->
	<template>
		<b-row>
			<b-col>
				<b-card>
					<div slot="header">
						<div class="row">
							<div class="d-flex justify-content-center align-items-center col-3">
								<h5 class="mb-0" style="white-space: nowrap">{{
									$t('sidebar.warehouse-management.items-section2') }}</h5>
								<!--<b-form-radio-group-->
								<!--id="btn-radios-2"-->
								<!--v-model="selected"-->
								<!--:options="options"-->
								<!--class="ml-3"-->
								<!--buttons-->
								<!--button-variant="outline-primary"-->
								<!--size="sm"-->
								<!--name="radio-btn-outline"-->
								<!--style="white-space: nowrap;"-->
								<!--&gt;</b-form-radio-group>-->
							</div>
							<div class="col-6"></div>
							<div v-if="selected=='sklad'" class="card-header-actions col-2"
								 style="display: flex;justify-content: flex-end;">
								<vs-dropdown vs-custom-content vs-trigger-click>
									<b-link href.prevent class="card-header-action btn-setting" style="font-size: 15px">
										<i class="fa fa-th"></i>
									</b-link>
									<vs-dropdown-menu class="columns-dropdown">
										<visible-columns :default-fields="columns"
														 @result="columnListener"></visible-columns>
									</vs-dropdown-menu>
								</vs-dropdown>


							</div>
						</div>
					</div>
					<b-card-body>
						<FilterWarehouse
							:departments="myDepartments"
							@filter="filter"
							ref="myFilter"
							@myEvent="myEvent"
							:loading="loading"
						>

						</FilterWarehouse>
						<b-row v-if="emptyTable" class="mb-3">
							<b-col v-if="Object.keys(stats).length === 0" class="myContainer">
								<b-alert variant="danger" v-if="!loading" show>Нет доступных данных</b-alert>
								<div v-if="loading" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</b-col>
							<b-col v-if="selected=='sklad' && Object.keys(stats).length>0">
								<b-button @click="excelExport('tblData')" variant="primary" :disabled="loading">{{
									$t('скачать Excel файл')
									}}
								</b-button>

							</b-col>
						</b-row>
						<!--<div v-if="selected=='sklad' || !emptyTable" class="generalTableClass myContainer">-->
						<!--<div v-if="loading && Object.keys(stats).length !== 0" class="spinner-wrapper">-->
						<!--<b-spinner variant="primary"></b-spinner>-->
						<!--</div>-->
						<!--<table class="table b-table table-striped" size="xs" id="tblData">-->
						<!--<template v-for="(key,item,index) in stats">-->
						<!--<template v-if="index === 0">-->
						<!--<tr>-->
						<!--<th :colspan="lengthOfColumn()" rowspan="2">&nbsp;</th>-->
						<!--<th scope="col" colspan="7"-->
						<!--class="textAlignCenter">-->
						<!--<span v-for="(value, refFieldKey) in depsName">-->
						<!--<span>{{ value.name}} </span>-->
						<!--<span style="margin-left: 17px;" v-if="value.name">    </span>-->
						<!--</span>-->
						<!--</th>-->
						<!--</tr>-->
						<!--<tr>-->
						<!--<template v-for="(value, refFieldKey) in refField">-->
						<!--<th class="textAlignCenter">-->
						<!--{{ value.totalCount |-->
						<!--currency({-->
						<!--symbol: '', fractionCount: 2, symbolPosition: 'back',-->
						<!--thousandsSeparator: ' '-->
						<!--}) }}-->
						<!--</th>-->
						<!--<th v-if="value.totalSumOfIncomeUzs > 0" colspan="2"-->
						<!--class="textAlignCenter">-->
						<!--{{ value.totalSumOfIncomeUzs | currency({-->
						<!--symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',-->
						<!--thousandsSeparator: ' '-->
						<!--})}}-->
						<!--</th>-->
						<!--<th v-else colspan="2" class="textAlignCenter"></th>-->

						<!--<th v-if="value.totalSumOfPriceUzs > 0" colspan="2" class="textAlignCenter">-->
						<!--{{ value.totalSumOfPriceUzs | currency({-->
						<!--symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',-->
						<!--thousandsSeparator: ' '-->
						<!--})}}-->
						<!--</th>-->
						<!--<th v-else colspan="2" class="textAlignCenter"></th>-->

						<!--<th v-if="value.totalSumOfPriceWholesale > 0" colspan="2"-->
						<!--class="textAlignCenter">-->
						<!--{{ value.totalSumOfPriceWholesale | currency({-->
						<!--symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',-->
						<!--thousandsSeparator: ' '-->
						<!--})}}-->
						<!--</th>-->
						<!--<th v-else colspan="2" class="textAlignCenter"></th>-->
						<!--</template>-->
						<!--</tr>-->
						<!--</template>-->
						<!--<template v-if="index === 0">-->
						<!--<tr>-->
						<!--<th v-for="column in columns" v-if="column.visible"-->
						<!--rowspan="2"-->
						<!--style="vertical-align: middle;"-->
						<!--:class="[column.key === 'id' ? 'textAlignCenter' : '', column.key === 'name' ? 'whTableColumnName' : '']"-->
						<!--&gt;-->
						<!--{{ column.label}}-->
						<!--</th>-->
						<!--<template v-for="(key,value) in refField">-->
						<!--<th class="textAlignCenter" rowspan="2"-->
						<!--style="vertical-align: middle;">-->
						<!--{{$t('sale.kol-vo')}}-->
						<!--</th>-->
						<!--<th class="textAlignCenter" colspan="2">{{ $t('warehouse.table.tableIncome')-->
						<!--}}-->
						<!--</th>-->
						<!--<th class="textAlignCenter" colspan="2">{{-->
						<!--$t('warehouse.table.tableWholesale') }}-->
						<!--</th>-->
						<!--<th class="textAlignCenter" colspan="2">{{ $t('warehouse.table.tableRetail')-->
						<!--}}-->
						<!--</th>-->
						<!--</template>-->
						<!--</tr>-->
						<!--<tr>-->
						<!--<template v-for="(key,value) in refField">-->
						<!--<th class="textAlignCenter">{{ $t('warehouse.table.incomeUzs') }}</th>-->
						<!--<th class="textAlignCenter">{{ $t('warehouse.table.totalIncomeUzs') }}</th>-->
						<!--<th class="textAlignCenter">{{ $t('warehouse.table.priceWholesale') }}</th>-->
						<!--<th class="textAlignCenter">{{ $t('warehouse.table.totalPriceWholesale')-->
						<!--}}-->
						<!--</th>-->
						<!--<th class="textAlignCenter">{{ $t('warehouse.table.priceUzs') }}</th>-->
						<!--<th class="textAlignCenter">{{ $t('warehouse.table.totalPriceUzs') }}</th>-->
						<!--</template>-->
						<!--</tr>-->
						<!--</template>-->
						<!--<template>-->
						<!--<tr style="background-color: gainsboro">-->
						<!--<td colspan="80" class="textAlignCenter"><b>{{ item }}</b></td>-->
						<!--</tr>-->
						<!--</template>-->

						<!--<template>-->
						<!--<tr v-for="(item, index) in key">-->
						<!--<td v-for="column in columns" v-if="column.visible"-->
						<!--:class="[column.key === 'id' ? 'textAlignCenter' : '', column.key === 'name' ? 'whTableColumnName' : '']"-->
						<!--&gt;-->
						<!--<template v-if="column.key === 'id'">{{ index +1 }}</template>-->
						<!--<template v-else>{{ item[column.key]}}</template>-->
						<!--</td>-->

						<!--<template v-for="(dep,idx) in refField">-->
						<!--<td v-html="$options.filters.currency(returnValueOfDep(dep.name,item.deps,idx,'inventory'), {symbol: '', fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->

						<!--<td v-if="item.deps"-->
						<!--v-html="$options.filters.currency(item.deps[dep.name].incomeUzs, {symbol: dep.currencyName, fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->
						<!--<td v-else-->
						<!--class="textAlignCenter"></td>-->

						<!--<td v-if="item.deps"-->
						<!--v-html="$options.filters.currency(item.deps[dep.name].incomeUzs * item.deps[dep.name].inventory, {symbol: dep.currencyName, fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->
						<!--<td v-else-->
						<!--class="textAlignCenter"></td>-->

						<!--<td v-if="item.deps"-->
						<!--v-html="$options.filters.currency(item.deps[dep.name].priceWholesale, {symbol: dep.currencyName, fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->
						<!--<td v-else-->
						<!--class="textAlignCenter"></td>-->

						<!--<td v-if="item.deps"-->
						<!--v-html="$options.filters.currency(item.deps[dep.name].priceWholesale * item.deps[dep.name].inventory, {symbol: dep.currencyName, fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->
						<!--<td v-else-->
						<!--class="textAlignCenter"></td>-->

						<!--<td v-if="item.deps"-->
						<!--v-html="$options.filters.currency(item.deps[dep.name].priceUzs, {symbol: dep.currencyName, fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->
						<!--<td v-else-->
						<!--class="textAlignCenter"></td>-->

						<!--<td v-if="item.deps"-->
						<!--v-html="$options.filters.currency(item.deps[dep.name].priceUzs * item.deps[dep.name].inventory, {symbol: dep.currencyName, fractionCount: 2})"-->
						<!--class="textAlignCenter"></td>-->
						<!--<td v-else-->
						<!--class="textAlignCenter"></td>-->
						<!--</template>-->


						<!--</tr>-->

						<!--</template>-->

						<!--</template>-->

						<!--</table>-->


						<!--</div>-->

						<b-modal v-model="isOpenRequest" size="xl" :title="$t('incomes.create.create-request')" hide-footer>
							<create-request

							:departments="myDepartments" @closeModal="closeModal" :itemList="checkedItems"
											:draftObject="draftObject"></create-request>

						</b-modal>
						<div v-if="selected=='sklad-5'">
							<div v-if="loading" class="spinner-wrapper">
								<b-spinner variant="primary"></b-spinner>
							</div>
							<div class="table mt-1  col-12"
								 v-for="(value, name,index) in this.stats">
								<div  class="pb-2">
									<b-row>
										<b-col cols="6">
											<span style="font-weight: bold">{{name}}</span>
										</b-col>
										<b-col cols="6" class="text-right">
										<b-button v-if="Object.keys(stats).length>0" class="mr-4 mb-2" variant="success" size="sm"
											@click="openZayavka(value)">{{$t('incomes.create.create-request')}}
										</b-button>
										</b-col>
									</b-row>
								</div>
								<div class="scrollTable">
								<table class="table b-table table-striped" fixed size="xs">
									<thead>
									<tr>
										<th style="width: 3%;text-align: center">
											<vs-checkbox type='checkbox' @click='checkAll(value.items)' :key="isCheckAll"
														 v-model="isCheckAll"></vs-checkbox>
										</th>
										<th style="width: 5%;text-align: center">№</th>
										<th class="alignedRight"
											style="width: 18%">
											{{$t('reference.name')}}
										</th>
										<th class="alignedRight"
											style="width: 6%">
											{{$t('goods.artikul')}}
										</th>

										<th style="width: 10%" class="alignedCenter">{{$t('goods.barcode')}}</th>
										<th style="width: 10%" class="alignedCenter">{{$t('goods.color')}}</th>
										<th style="width: 6%" class="alignedCenter">{{$t('goods.brand')}}</th>
										<th class="textAlignCenter" style="width: 4%">{{$t('sale.kol-vo')}}</th>
										<!--<th class="alignedRight" style="width: 12%">Кол-во Транзакции</th>-->
										<!-- <th v-if="isAdmin" class="textAlignCenter" style="width: 8%">{{ $t('prices.item.sum') }}</th> -->
										<th v-if="isAdmin && checkSaleType == 'WHOLE'" class="textAlignCenter" style="width: 13%">{{
											$t('prices.item.lastPriceWholesale') }}
										</th>
										<th v-if="isAdmin && checkSaleType == 'RETAIL'" class="textAlignCenter" style="width: 10%">{{ $t('prices.item.sum-new') }}
										</th>


									</tr>
									</thead>
									<tbody>
									<tr v-for="(item, index) in value.items" :key="index"
									:class="[item.isItemDublicate? 'table-warning' : '']"
							 		   :id="'tooltip-target' + item.itemId">
										<!--<td>{{name}}</td>-->
										<td style="text-align: center">
											<vs-checkbox type="checkbox"
														 :id="item.itemId"
														 :vs-value="item"
														 :disabled="item.isItemDublicate"
														 v-model="checkedItems"/>

										</td>
										<td style="text-align: center">
											<strong>{{paginate(index, value.depId, search.limit)}}</strong>
										</td>
										<td>{{item.itemName}}
										<td>{{item.artikul}}
										</td>

										<!--<td>{{value[value.length-1].maxValue}}</td>-->
										<td>{{item.barcode}}</td>
										<td>{{item.colorName}}</td>
										<td>{{item.brand}}</td>
										<td style="text-align: center">{{item.inventory}}</td>

										<!-- <td v-if="isAdmin" style="text-align: center">{{item.incomeUzs| currency({
											symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}
										</td> -->
										<td v-if="isAdmin && checkSaleType == 'WHOLE'" style="text-align: center">{{item.priceWholesale| currency({
											symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}
										</td>
										<td v-if="isAdmin &&  checkSaleType == 'RETAIL'" style="text-align: center">{{item.priceUzs| currency({
											symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',
											thousandsSeparator: ' '
											})}}
										</td>

										<b-tooltip
										v-if="item.isItemDublicate"
										:target="'tooltip-target' + item.itemId" triggers="hover">
										Цены на этот товаров не равны, пожалуйста, сравните цены
									 </b-tooltip>
									</tr>
									<tr v-if="value.items">
										<td v-if="value.items.length==0" colspan="11"><h4 style="text-align: center">Пока
											нет
											доступных данных</h4>
										</td>
									</tr>
									</tbody>

								</table>
								</div>

								<!-- <div class="row" style="display: flex;justify-content:space-between">
									<div class="col-4">
										<nav> -->
											<!-- <b-pagination size="sm"
															:total-rows="value.total"
															:per-page="search.limit"
														  :value="currentPageMethod(value.depId)"
														  :prev-text="$t('pagination.prev')"
														  :next-text="$t('pagination.next')"
														  @input="paginateByDep($event, value.depId)"
														  hide-goto-end-buttons /> -->
										<!-- </nav>
									</div>
									<div class="col-2">


									</div>
								</div> -->
							</div>
						</div>


					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</template>
<!-- </keep-alive> -->

<script>
	import {mapActions, mapGetters, mapState} from "vuex";
	import FilterWarehouse from "./blocks/Filter";
	import VisibleColumns from "../warehouse-management/goods/blocks/VisibleColumns";
	import {TokenService} from "../../services/storage.service";
	import CreateRequest from "./blocks/createRequest";
	import WhDocument from "../../services/wh-document.service";

	export default {
		name: 'Index',
		components: {
			CreateRequest,
			FilterWarehouse,
			VisibleColumns,
			TokenService
		},

		computed: {
			checkSaleType() {
				if(Object.values(this.stats)[0]) {
					for(let i =0; i<this.myDepartments.length; i++) {
						if(Object.values(this.stats)[0].depId == this.myDepartments[i].id) {
								return this.myDepartments[i].saleType
						}
					}
				}
				// return JSON.parse(Object.values(this.stats)[0].depId)
			},
			...mapGetters('departments', [
				'myDepartments'
			]),
			...mapState('warehouse', ['loading']),
			...mapState('warehouse', {
				'stats': 'filteredItems'
			}),
			...mapState(['isCashier','isAdmin']),
			formatted() {
				const indexs = Object.keys(this.priceStats);

				const formatted = [];

				indexs.map(index => {
					formatted.push({
						name: index,
						items: this.priceStats[index]
					});
				});

				return formatted;
			}
		},

		methods: {
			myEvent() {
				if(this.checkedItems.length > 0) {
					this.checkedItems = []
				}
			},
			checkAll: function (items) {
				this.isCheckAll = !this.isCheckAll;
				this.checkedItems = [];
				if (this.isCheckAll) { // Check all
					for (let i = 0; i < items.length; i++) {
						if(!items[i].isItemDublicate) {
							this.checkedItems.push(items[i])
						}
					}
				}


			},
			closeModal() {
				this.checkedItems = [];
				this.isCheckAll = false;
				this.isOpenRequest = false;
			},
			openZayavka(item) {
				if (this.checkedItems.length !== 0) {
					this.$store.commit('warehouse/setItemsForModal', this.checkedItems);
					this.isOpenRequest = true;

					WhDocument.createRequestDraft('DRAFT').then(res => {
						this.draftObject = res.data;
					});
				} else {
					this.$vs.notify({
						text: this.$t('please-select-product'),
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					})
				}

			},
			paginate(index, depId, page_number) {
				let dep = this.pageDep.find(el => {
					return el.depId == depId;
				});
				// --page_size;
				return dep ? (page_number * (dep.page - 1)) + index + 1 : (page_number * (1 - 1)) + index + 1;
			},
			currentPageMethod(depId) {
				let dep = this.pageDep.find(el => {
					return el.depId == depId;
				});
				return dep ? dep.page : 1;
			},
			paginateByDep(event, depId) {
				this.pageDep.forEach(el => {
					if (el.depId == depId) {
						el.page = event;
					}
				})
				let obj = {
					departments: this.pageDep,
					selected: this.selected,
					link: [],
				};

				this.getBalancePrice(obj)

			},
			...mapActions('departments', ['fetchMyDepartments']),
			...mapActions('warehouse', ['getBalancePrice']),

			async filter($event) {
				let obj = {};
				this.pageDep = [];
				if ($event.depsId) {
					if ($event.depsId.depIds) {
						for (let i = 0; i < $event.depsId.depIds.length; i++) {
							let tempForDep = {
								page: this.search.page,
								limit: this.search.limit,
								depId: $event.depsId.depIds[i]
							}
							this.pageDep.push(tempForDep);
						}
						obj.pageDep = this.pageDep;
					}
				}

				this.refField = []
				if (!$event.empty) {
					this.depsName = $event.depNames
					this.depsName.forEach(el => {
						if (this.selected == 'sklad') {
							this.addRefFiled(el)
						}
					});

					this.emptyTable = true;
					$event.selected = this.selected;
					$event.departments = obj.pageDep;


					await this.getBalancePrice($event);

					/* CALCULATE TOTALCOUNT AND SUM FOR EACH DEPARTMENT */
					let keys = Object.keys(this.stats);
					if (keys[0] == 'MAGAZIN') {
						this.stats['MAGAZIN'].forEach(item => {
							Object.keys(item.deps).forEach(key => {
								let value = item.deps[key];
								this.refField.forEach(dep => {
									if (key == dep.name) {
										dep.totalCount += parseFloat(value.inventory);
										dep.totalSumOfIncomeUzs += parseFloat(value.incomeUzs) * parseFloat(value.inventory);
										dep.totalSumOfPriceUzs += parseFloat(value.priceUzs) * parseFloat(value.inventory);
										dep.totalSumOfPriceWholesale += parseFloat(value.priceWholesale) * parseFloat(value.inventory);
									}
								})
							});
						})
					}
					// else if(responseObj){
					// 	if (responseObj.length>0){
					// 		let value = Object.values(this.stats);
					// 		// value.forEach(key => {
					// 		//
					// 		// 	// Object.keys(item.deps).forEach(key => {
					// 		// 	// 	let value = item.deps[key];
					// 		// 	// 	this.refField.forEach(dep => {
					// 		// 	//
					// 		// 	// 			dep.totalCount += parseFloat(value.items.inventory);
					// 		// 	// 			dep.totalSumOfIncomeUzs += parseFloat(value.items.incomeUzs) * parseFloat(value.items.inventory);
					// 		// 	// 			dep.totalSumOfPriceUzs += parseFloat(value.items.priceUzs) * parseFloat(value.items.inventory);
					// 		// 	// 			dep.totalSumOfPriceWholesale += parseFloat(value.items.priceWholesale) * parseFloat(value.items.inventory);
					// 		// 	// 	})
					// 		// 	// });
					// 		// })
					// 	}
					// }
				} else {
					this.$store.commit('warehouse/setFilteredItems', []);
					this.emptyTable = false
				}
			},

			lengthOfColumn() {
				let col = this.columns.filter(column => {
					if (column.visible) {
						return column
					}
				});
				return col.length

			},

			columnListener($event) {
				this.columns = $event
			},
			addRefFiled(depNameAndCurrency) {
				if (this.refField.findIndex(el => {
					return el.name == depNameAndCurrency.name
				}) === -1) {
					let temp = {
						name: depNameAndCurrency.name,
						currencyName: depNameAndCurrency.currencyName,
						totalCount: 0,
						totalSumOfIncomeUzs: 0,
						totalSumOfPriceUzs: 0,
						totalSumOfPriceWholesale: 0
					};
					this.depsName.push(temp.name);
					if (this.selected == 'sklad') {
						if (this.refField.length < 1) {
							this.refField.push(temp)
						}
					}

				}
			},

			returnValueOfDep(dep, itemDeps, index, what, depCurrencyName) {
				if (itemDeps !== undefined) {
					if (itemDeps[dep] && index === this.refField.findIndex(el => {
						return el.name == dep
					})) {
						if (what === 'inventory') {
							return itemDeps[dep][what];
						} else {
							return itemDeps[dep][what] * itemDeps[dep]['inventory'];
						}

					} else {
						if (what === 'inventory') {
							return 0;
						} else {
							return `0 ${depCurrencyName}`;
						}
					}
				}
			},
			excelExport(tableID, filename = '') {

				var downloadLink;

				var dataType = 'text/xls;charset=UTF-8';
				//var dataType = 'application/vnd.ms-excel';
				var tableSelect = document.getElementById(tableID);
				var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

				// Specify file name
				filename = filename ? filename + '.xls' : 'excel_data.xls';

				// Create download link element
				downloadLink = document.createElement("a");

				document.body.appendChild(downloadLink);

				if (navigator.msSaveOrOpenBlob) {
					var blob = new Blob(['\ufeff', tableSelect], {
						encoding: "utf-8",
						type: dataType
					});
					navigator.msSaveOrOpenBlob(blob, filename);
				} else {
					// Create a link to the file
					downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

					// Setting the file name
					downloadLink.download = filename;

					//triggering the function
					downloadLink.click();
				}

			},

		},

		data() {
			return {
				draftObject: {},
				isOpenRequest: false,
				isCheckAll: false,
				checkedItems: [],
				pageDep: [],
				statusCheck: [],
				currentPage: 1,
				search: {
					page: 1,
					limit: 20
				},
				perPage: 20,
				selected: 'sklad-5',
				options: [
					{text: this.$t('sidebar.warehouse-management.items-section1'), value: 'sklad'},
					{text: this.$t('sidebar.warehouse-management.items-section2'), value: 'sklad-5'},

				],
				depName: [],
				priceStats: {},
				emptyTable: false,
				depsName: [],
				refField: [],
				allTotal: [],
				columns: [
					{
						key: 'id',
						label: '№',
						visible: true,
						changebale: true
					},
					{
						key: 'name',
						label: this.$t('goods.name'),
						visible: true,
						changebale: true
					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						visible: true,
						changebale: true
					},
					{
						key: 'color',
						label: this.$t('goods.color'),
						visible: true,
						changebale: true
					},
					{
						key: 'genderName',
						label: this.$t('goods.gender'),
						visible: true,
						changebale: true
					},
					{
						key: 'subName',
						label: TokenService.getDepartmentType() === 'SHOP' ? this.$t('client.create.customer') : 'Подкатегория 1',
						visible: true,
						changebale: true
					},
					/*{
						key: 'size',
						label: 'goods.size',
						visible: false,
						changebale: true
					},*/
					{
						key: 'brandName',
						label: this.$t('goods.brand'),
						visible: true,
						changebale: true
					},
					/*{
                        key: 'sectorName',
                        label: 'Sector',
                        visible: false,
                        changebale: true
                    },*/
					{
						key: 'barcode',
						label: this.$t('goods.barcode'),
						visible: false,
						changebale: true
					},
					{
						key: 'sub2Name',
						label: TokenService.getDepartmentType() === 'SHOP' ? this.$t('goods.category') : 'Подкатегория 2',
						visible: false,
						changebale: true
					},
					{
						key: 'sub3Name',
						label: TokenService.getDepartmentType() === 'SHOP' ? this.$t('goods.subcategory') : 'Подкатегория 3',
						visible: false,
						changebale: true
					},

				],
				loaderImg: {
					width: '80px',
					height: '80px',
				}
			}
		},

		mounted() {
			this.fetchMyDepartments();
			this.$store.commit('warehouse/setFilteredItems', []);

		},
		watch: {
			'selected': {
				handler() {
					this.depsName = [];
					this.refField = [];
					this.$refs.myFilter.setFilterToComponent();
				},
			},
			'checkedItems': {
				handler(newValue, oldValue) {
					if (newValue.length !== oldValue.length) {
						this.isCheckAll = false;
					}
					let itemPrice = Object.values(this.stats);
					if (itemPrice[0].items.length == newValue.length) {
						this.isCheckAll = true;
					}
				}
			}
		}


	}
</script>

<style scoped>
	.scrollTable {
		overflow-y: auto;
		height: 450px;
		display: block;
	}
	/*.width15_wordBreak {
		width: 14%;
	}*/
	.myContainer {
		overflow-x: auto;
		white-space: nowrap;
		position: relative;
	}

	.alert {
		padding: 15px;
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.loaderImg {
		position: absolute;
		left: 44%;
		top: 44%;
		z-index: 1;
		border: 6px solid #f3f3f3;
		border-radius: 50%;
		border-top: 6px solid #0092D3;
		border-bottom: 6px solid #0092D3;
		width: 60px;
		height: 60px;
		-webkit-animation: spin 1.6s linear infinite;
		animation: spin 1.6s linear infinite;
	}

	@-webkit-keyframes spin {
		0% {
			-webkit-transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
		}
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
